import { type FockNodeDownInner } from '@redteclab/api/clients/content-management-system'

export const headerFockNodeDownInnerAccessorDownNodeHasChildren = (
  node: FockNodeDownInner,
): boolean => {
  // @ts-expect-error type does not exist atm on the api
  return node.child_count > 0
}
